<in2-navbar [navbarClass]="navbarClass()"></in2-navbar>
<main>
    <router-outlet></router-outlet>
</main>
<footer>
    <div class="w-full app-container app-container-p">
        <div class="grid grid-cols-12 gap-2 md:gap-4 pt-6 mb-6">
            <div class="flex flex-col mb-6 md:mb-0 col-span-12 md:col-span-4">
                <img loading="lazy" width="204" height="79" class="mb-4 w-full max-w-[204px] h-auto mt-[-10px]" ngSrc="/assets/in2-logo.png" alt="IN2" i18n-alt="@@footerLogoAlt" />

                <p i18n="@@footerCompanyDescription">
                    IN2 is an innovative, socially responsible, award-winning communications and research company that drives positive change in communities.
                </p>

                <a class="font-semibold mt-4" href="mailto:registry@in2-comms.com">registry&#64;in2-comms.com</a>
            </div>

            <div class="flex flex-col flex-wrap mb-6 md:mb-0 col-span-12 md:col-span-4">
                <h2 class="heading-2 text-start text-primary mt-0 mb-6" i18n="@@footerLinksHeading">Links</h2>
                <div class="grid grid-cols-2 max-h-[175px] gap-4">
                    <a class="nav-link flex-auto" href="javascript:;" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" routerLink="/" i18n="@@navLinkHome"
                        >Home</a
                    >
                    <a
                        class="nav-link flex-auto"
                        href="javascript:;"
                        [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLink="/our-mission"
                        i18n="@@navLinkOurMission"
                        >Our Mission</a
                    >
                    <a
                        class="nav-link flex-auto"
                        href="javascript:;"
                        [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLink="/case-studies"
                        i18n="@@navLinkCaseStudies"
                        >Case Studies</a
                    >
                    <a
                        class="nav-link flex-auto"
                        href="javascript:;"
                        [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLink="/about-us"
                        i18n="@@navLinkAboutUs"
                        >About Us</a
                    >
                    <a
                        class="nav-link flex-auto"
                        href="javascript:;"
                        [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLink="/our-values"
                        i18n="@@navLinkOurValues"
                        >Our Values</a
                    >
                    <a
                        class="nav-link flex-auto"
                        href="javascript:;"
                        [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLink="/who-we-are"
                        i18n="@@navLinkWhoWeAre"
                        >Who We Are</a
                    >
                    <a class="nav-link flex-auto" href="javascript:;" (click)="contactUsDialogService.openContactUsDialog()" i18n="@@navLinkContactUs">Contact Us</a>

                    <a
                        class="nav-link flex-auto"
                        target="_blank"
                        href="https://www.linkedin.com/company/innovation-and-insight-fze-in2-comms-/jobs/"
                        i18n="@@navLinkJobOpportunities"
                        >Job Opportunities
                    </a>
                </div>
            </div>

            <div class="flex flex-col flex-wrap mb-6 md:mb-0 col-span-12 md:col-span-4">
                <h2 class="heading-2 text-primary text-start mb-6" i18n="@@footerOfficesHeading">Our Offices</h2>
                <p i18n="@@footerOfficeLocations">Istanbul | Dubai | London | Erbil | Amman | Warsaw | Nairobi | Damascus</p>

                <div class="flex items-end flex-wrap gap-4 xl:gap-8 mt-8">
                    <img loading="lazy" width="88" height="92" ngSrc="/assets/certs/un-global-compact.png" alt="un global compact" i18n-alt="@@certUNCompact" />
                    <img loading="lazy" width="88" height="81" ngSrc="/assets/certs/iso.png" alt="iso" i18n-alt="@@certISO" />
                    <img loading="lazy" width="104" height="87" ngSrc="/assets/certs/cyber-essentials-plus.png" alt="cyber essentials plus" i18n-alt="@@certCyberEssentials" />
                    <img loading="lazy" width="200" height="65" ngSrc="/assets/certs/sustainable-development-goals.png" alt="global compact" i18n-alt="@@certSustainableDev" />
                    <img loading="lazy" width="159" height="63" ngSrc="/assets/certs/meta.png" alt="iso" i18n-alt="@@certMeta" />
                </div>
            </div>
        </div>

        <div class="flex items-center justify-center flex-wrap mt-4 text-[14px]">
            <p class="text-slate-700 me-12" style="flex: 1 0 255px" i18n="@@footerCopyright"><strong>IN2</strong> &copy; All rights reserved {{ year }}</p>

            <div class="flex items-center gap-2 justify-end flex-auto">
                <a class="text-slate-700 hover:text-primary" href="javascript:;" routerLink="/privacy-policy" routerLinkActive="active" i18n="@@navLinkPrivacy">Privacy</a>

                <!-- add language selector with globe icon and bind its value to currentLanguage -->
                <span class="text-slate-700">|</span>
                <in2-language-selector></in2-language-selector>
            </div>
        </div>
    </div>
</footer>

<dialog id="contactUsDialog" class="backdrop">
    <div class="content">
        @if ((contactUsDialogService.events | async) === "opened") {
            <in2-contact-us-form></in2-contact-us-form>
        }
        <button
            (click)="contactUsDialogService.closeContactUsDialog($event)"
            id="closeMobileMenu"
            class="absolute top-0 right-0 m-4 text-gray-600 hover:text-gray-800"
            i18n-aria-label="@@closeButtonLabel"
            aria-label="Close"
        >
            <svg class="w-6 h-6 outline-none" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        </button>
    </div>
</dialog>
